import {put} from 'redux-saga/effects';
import config from '../../config';
import * as invoiceActionTypes from '../invoiceActionTypes';

const loadInvoiceSearchResults = function* loadInvoiceSearchResults(payload) {
    if (!payload) return;
    const {location} = payload.payload;
    const searchQueryParams = new URLSearchParams(location.search);
    if (!searchQueryParams.get('size')) searchQueryParams.append('size', `${config.DEFAULT_PAGE_SIZE}`);
    if (!searchQueryParams.get('sort')) searchQueryParams.append('sort', 'createdAt,desc');

    yield put({
        type: invoiceActionTypes.SEARCH_INVOICES,
        payload: {searchQueryParams},
    });
    window.sessionStorage.setItem('serviceCaseOriginRoute', location.pathname);
};

export default loadInvoiceSearchResults;
